import React from "react";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const ContactUs: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-white to-gray-100 py-16 px-6">
      <div className="container mx-auto max-w-6xl">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-gray-800 mb-4">
            Get in Touch
          </h2>
          <p className="text-lg text-gray-600">
            We'd love to hear from you! Feel free to reach out through any of
            the channels below.
          </p>
        </div>

        {/* Contact Info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {/* Email */}
          <div className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 text-center hover:shadow-2xl transition-shadow">
            <FaEnvelope className="text-blue-500 text-4xl mb-4" />
            <h4 className="text-xl font-medium text-gray-800 mb-2">Email</h4>
            <p className="text-gray-600">info@adinsinternational.com</p>
          </div>

          {/* Mobile */}
          <div className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 text-center hover:shadow-2xl transition-shadow">
            <FaPhone className="text-green-500 text-4xl mb-4" />
            <h4 className="text-xl font-medium text-gray-800 mb-2">Mobile</h4>
            <p className="text-gray-600">+919151816021</p>
          </div>

          {/* Address */}
          <div className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 text-center hover:shadow-2xl transition-shadow">
            <FaMapMarkerAlt className="text-red-500 text-4xl mb-4" />
            <h4 className="text-xl font-medium text-gray-800 mb-2">Address</h4>
            <p className="text-gray-600">Plot No. 1, Jagat Khera Rd, near to Saint Martin Academy, Jagat khera, Kalli Pashchim,Lucknow,Uttar Pradesh 226014</p>
          </div>
        </div>

        {/* Google Map */}
        <div className="mb-16">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.7259681598253!2d80.86093241501027!3d26.846693983151994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfd12f43b9ed7%3A0xe6af733497fcbb65!2sKalli%20Paschim%2C%20Lucknow%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1696541358894!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
            className="rounded-lg shadow-lg"
          ></iframe>
        </div>

        {/* Social Media */}
        <div className="text-center">
          <h3 className="text-3xl font-medium text-gray-800 mb-6">Follow Us</h3>
          <div className="flex justify-center space-x-8 text-3xl">
            <a
              href="https://www.facebook.com/adinsinternational"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-blue-500 transition-colors"
            >
              <FaFacebook />
            </a>
            <a
              href="https://x.com/adinsinternati8"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-blue-400 transition-colors"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.linkedin.com/company/adins-international/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn className="h-6 w-6 hover:text-blue-700 transition-colors" />
            </a>
            <a
              href="https://www.instagram.com/adins.international/?igsh=MTE4OHVvd2JienBpdA%3D%3D#"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-pink-500 transition-colors"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
